var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8019 10.0289L9.16132 8.67109C8.62422 8.51641 8.25039 8.01367 8.25039 7.45508C8.25039 6.75469 8.81758 6.1875 9.51797 6.1875H12.3668C12.891 6.1875 13.4066 6.34648 13.8363 6.63867C14.0984 6.81484 14.4508 6.77187 14.6742 6.55273L16.1695 5.0918C16.4746 4.79531 16.4316 4.30117 16.0922 4.03906C15.0394 3.21406 13.7246 2.7543 12.3754 2.75V0.6875C12.3754 0.309375 12.066 0 11.6879 0H10.3129C9.93476 0 9.62539 0.309375 9.62539 0.6875V2.75H9.51797C6.78086 2.75 4.58086 5.10039 4.83437 7.88906C5.01484 9.86992 6.52734 11.4813 8.43515 12.0398L12.8394 13.3289C13.3766 13.4879 13.7504 13.9863 13.7504 14.5449C13.7504 15.2453 13.1832 15.8125 12.4828 15.8125H9.63398C9.10976 15.8125 8.59414 15.6535 8.16445 15.3613C7.90234 15.1852 7.55 15.2281 7.32656 15.4473L5.83125 16.9082C5.52617 17.2047 5.56914 17.6988 5.90859 17.9609C6.96133 18.7859 8.27617 19.2457 9.62539 19.25V21.3125C9.62539 21.6906 9.93476 22 10.3129 22H11.6879C12.066 22 12.3754 21.6906 12.3754 21.3125V19.2414C14.3777 19.2027 16.2555 18.0125 16.9172 16.1176C17.841 13.4707 16.2898 10.7551 13.8019 10.0289Z",
    fill: "#FB3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a9d17160685d3b54630a7de520ffa4ed.svg";
export { ForwardRef as ReactComponent };